/**
 * @file 获取单个学员问卷提交信息
 * @author Kody
 * @date 2019-09-27
 * @see http://api.umucdn.cn/project/51/interface/api/2585
 */

import Api from '../../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface ISurveyUserResultInput {
    element_id: number; // 问卷ID
    question_ids: string; // 问题 ids
}

// tslint:disable-next-line:max-line-length
export const getUserResult = (data: ISurveyUserResultInput): Promise<IResponse<IServerUserResultMap>> => {
    return fetchData(Api.GET_USER_RESULT, data).then((res: IResponse<IServerUserResultMap>) => {
        return res;
    });
};

export const getUserResultSync = fetchDataSync(getUserResult);
